import { DOC_HOST } from '../../base/constants/cgi-base';
// 企微通知设置url
export var NOTIFY_SCOPE = "".concat(DOC_HOST, "/wedoc/notifyscope");
// 编辑通知
export var EDIT_NOTIFY = "".concat(DOC_HOST, "/wedoc/editnotify");
